import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'supplyAppointmentPartDay'
})
export class SupplyAppointmentPartDayPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    switch (value) {
      case 'Morning':
        return 'Vormittags';
      case 'Afternoon':
        return 'Nachmittags';
    }
    return value;
  }
}
